import { Controller, FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DevTool } from "@hookform/devtools";
import schema from "./Validation";
import { Grid, MenuItem } from "@mui/material";
import { AcademicLevel, Campaigns,  ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components";
import { Email, InputText, PhoneNumber } from "components/fields";
import { useForms, useSalesforce, useUrlReturn } from "hooks";
import {
  campaigns,
  consent, consentement, defaultValues,specialities
} from "services";
import DropdownCommon from "components/fields/DropdownCommon";
import formations from "../services/formations";



const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar, setSnackMessage, setSnackSeverity } = useForms();
  const { url } = useUrlReturn('ISTM-JPO');
  const { url: url_contact } = useUrlReturn('ISTM-CONTACT');


  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      lead: {
        ...defaultValues,
        ...specialities.lead,
        ...consentement,
        Campus__c: 'Paris',
        Section__c: '',
        Wished_Programm__c: '',
        LastForm__c:'JPO',
      }
    },
    resolver: yupResolver(schema)
  });
  const { control, watch } = methods;
    //console.log('Selected campaign:', campaignId, 'Is online:', isOnline, 'Last form:', lastForm);


  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false);
    const lead = data.lead;
    const campaignId = data.campaignId;
    const campus = data.lead.Campus__c || 'Paris';


    const defaultDataLead = {
      Division__c: 'IONIS STM',
      IONISSchool__c: 'IONIS STM',
      LeadSource: 'JPO',
      RecordTypeId: recordTypeId
    };


    const finalLead = { ...lead, ...defaultDataLead };

    try {
      const leadCreated = await salesforce.createLead(finalLead);


      if (campaignId !== 'unavailable') {
        const campaignMember = {
          CampaignId: campaignId,
          LeadId: leadCreated.Id,
          Status: data.status,
        };
        await salesforce.createCampaignMember(campaignMember);
        document.location.href = url;
      } else {
        document.location.href = url_contact;
      }
    } catch (error) {
      console.error(' Error during form submission:', error);
      setError('Une erreur est survenue lors de la soumission du formulaire', error);
    }
  };

  useSalesforce('Ionis-STM', false);


  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <Grid item xs={12}>
          {/** Dropdown normal for Wished Program */}
          <Controller
            control={control}
            name="lead.Wished_Programm__c"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <DropdownCommon
                label="Par quelle filière êtes-vous intéressé(e) ?"
                name="lead.Wished_Programm__c"
                onChange={onChange}
                value={value || ''}
                error={error}
                required
                renderOptions={formations.map(formation => (
                  <MenuItem key={formation.value} value={formation.value}>
                    {formation.label}
                  </MenuItem>
                ))}
              />
            )}
          />
        </Grid>
        <AcademicLevel school="IONIS STM" section={false} />
        <Campaigns contact={false} division="IONIS STM" last_form="JPO" school="IONIS STM" text="à la Journée Portes Ouvertes" textAvailability="pour nos journées portes ouvertes" type="JPO" />
        {/* <Disponibilites text="les Journées Portes Ouvertes" /> */}

        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="JPO" school="IONIS STM" />
      </Grid>
    </FormProvider>
  )
};

export default Form;
